import script from "./InspectionGroupTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectionGroupTable.vue?vue&type=script&lang=ts&setup=true"

import "./InspectionGroupTable.vue?vue&type=style&index=0&id=69ffa5d5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69ffa5d5"]])

export default __exports__